import React from 'react';
import { observer } from '@poa/state';

export const DataTableCaption = observer(({ data, isOpened }) => {
  if (!data.get().title) {
    return null;
  }

  return (
    <div className={`table-container__head ${isOpened.get() ? '' : 'is-closed'}`}>
      <button className="table-container__toggle" onClick={() => isOpened.set(!isOpened.get())}>
        <svg className="icon icon-arrow-bottom">
          <svg id="icon-arrow-bottom" viewBox="0 0 9.5 4.93" width="100%" height="100%">
            <path d="M4.75 4.93L0 .75.66 0l4.09 3.6L8.84 0l.66.75-4.75 4.18z" />
          </svg>
        </svg>
      </button>
      <h2>
        {data.get().title} {data.get().groupedTotal || null}
      </h2>
    </div>
  );
});
